export default __webpack_public_path__ + "static/icon-1-4ef2710e550dece1d28addcfeecf3fe9.png";